:host {
  display: block;
  width: 100%;
  height: 100%;
}

.ai-chat-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.loading-state,
.error-state,
.empty-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--ux-color-text-secondary);

  ux-icon {
    color: var(--ux-color-text-secondary);
  }
}

.error-state {
  color: var(--ux-color-error);

  ux-icon {
    color: var(--ux-color-error);
  }
}
